import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";

const signOut = (username) => {
  const poolData = {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID,
    ClientId: process.env.REACT_APP_CLIENT_ID,
  };
  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
  const userData = {
    Username: username,
    Pool: userPool,
  };

  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

  if (cognitoUser !== null) {
    cognitoUser.signOut();
  }
};

export default signOut;
